<template>
    <div ref="chartDom" id="myEcharts" style="width: 300px; height: 300px;"></div>
</template>

<script>
import * as echarts from 'echarts';
import resize from "@/mixins/chartResize";

export default {
    mixins: [resize],
    props: {
        dataArr: Array,
        totalText: Number
    },
    data(){
        return{
            chart: null,
            option: {}
        }
    },
    watch:{
        totalText:{
            handler(){
                // this.chart.setOption(this.option);
                this.init();
            }
        }
    },
    methods: {
        init() {
            const {dataArr, totalText} = this
            // let dataArr = [128, 32, 4, 0,0,0,0,0]
            // let totalText = '12'
            let pieColor = ["#F6FF69", "#5CFF42", "#83A9FF", "#83ECFF", "#E483FF", "#FF9883", "#83FFC2", "#F96868", "#F9AC68"]

            this.option = {
                title: {
                    text: '总计',
                    subtext: `${totalText}人`,
                    textStyle: {
                        color: '#ffffff',
                        fontSize: 14,
                    },
                    subtextStyle: {
                        color: '#13FFEE',
                        fontSize: 12,
                    },
                    x: 'center',
                    y: '40%',
                },
                color: pieColor,
                grid: {
                    left: 5,
                    top: 5,
                    bottom: 5,
                    right: 5,
                    containLabel: true
                },
                
                tooltip: {
                    trigger: 'item',
                    show: false,
                    formatter: "{b} : {c} ({d}%) "
                },
                calculable: true,
                series: [
                    {
                        type: 'pie',
                        radius: ["35%", "45%"],
                        hoverAnimation: false,
                        label: {
                            position: 'outer',
                            alignTo: 'none',
                            bleedMargin: 5
                        },
                        labelLine: {
                            normal: {
                                show: false,
                                length: 3,
                                length2: 5
                            },
                            emphasis: {
                                show: false
                            }
                        },
                        data: [{
                            name: '',
                            value: 0,
                            itemStyle: {
                                normal: {
                                    color: "#0B4A6B"
                                }
                            }
                        }]
                    }, {
                        type: 'pie',
                        radius: ["20%", "21%"],
                        hoverAnimation: false,
                        label: {
                            position: 'outer',
                            alignTo: 'none',
                            bleedMargin: 5
                        },
                        labelLine: {
                            normal: {
                                show: false,
                                length: 3,
                                length2: 5
                            },
                            emphasis: {
                                show: false
                            }
                        },
                        data: [{
                            name: '',
                            value: 0,
                            itemStyle: {
                                normal: {
                                    color: "#0B4A6B"
                                }
                            }
                        }]
                    },{
                        type: 'pie',
                        radius: ["35%", "38%"],
                        hoverAnimation: false,
                        padAngle: 15,
                        label: {
                            position: 'outer',
                            alignTo: 'none',
                            bleedMargin: 5
                        },
                        labelLine: {
                            normal: {
                                show: false,
                                length: 3,
                                length2: 5
                            },
                            emphasis: {
                                show: false
                            }
                        },
                        data: [
                            { name: '', value: 0, itemStyle: { normal: { color: "#3A496D" } } },
                            { name: '', value: 0, itemStyle: { normal: { color: "#3A496D" } } },
                            { name: '', value: 0, itemStyle: { normal: { color: "#3A496D" } } },
                            { name: '', value: 0, itemStyle: { normal: { color: "#3A496D" } } },
                            { name: '', value: 0, itemStyle: { normal: { color: "#3A496D" } } },
                            { name: '', value: 0, itemStyle: { normal: { color: "#3A496D" } } },
                            { name: '', value: 0, itemStyle: { normal: { color: "#3A496D" } } },
                            { name: '', value: 0, itemStyle: { normal: { color: "#3A496D" } } },
                            { name: '', value: 0, itemStyle: { normal: { color: "#3A496D" } } },
                        ]
                    }, {
                        type: 'pie',
                        radius: ["40%", "39%"],
                        hoverAnimation: false,
                        label: {
                            position: 'outer',
                            alignTo: 'none',
                            bleedMargin: 5
                        },
                        labelLine: {
                            normal: {
                                show: false,
                                length: 3,
                                length2: 5
                            },
                            emphasis: {
                                show: false
                            }
                        },
                        name: "",
                        data: [{
                            name: '',
                            value: 0,
                            itemStyle: {
                                normal: {
                                    color: "#0B4A6B"
                                }
                            }
                        }]
                    }, 
                    {
                        type: 'pie',
                        radius: ['30%', '40%'],
                        // avoidLabelOverlap: false,
                        itemStyle: {
                            borderColor: '#fff',
                            borderWidth: 1
                        },
                        label: {
                            // alignTo: 'edge',
                            // formatter: '{name|{b}}\n{time|{c} 小时}',
                            minMargin: 5,
                            edgeDistance: 10,
                            lineHeight: 15,
                            normal: {
                                show: true,
                                formatter: function (params) {
                                    return params.name + ' ' + params.value + '人'
                                },
                                textStyle: {
                                    fontSize: 9,
                                    color: '#FFFFFF'
                                },
                            },
                            // textStyle: {
                            //         fontSize: 13,
                            //         color: '#FFFFFF'
                            //     },
                            // rich: {
                            //     time: {
                            //         fontSize: 12,
                            //         color: '#FFFFFF'
                            //     }
                            // }
                        },
                        labelLine: {
                            length: 16,
                            length2: 5,
                            // maxSurfaceAngle: 80
                        },
                        // labelLayout: function (params) {
                        //     console.log('params----', params)
                        //     // const isLeft = params.labelRect.x < this.chart.getWidth() / 2;
                        //     const isLeft = 1;
                        //     const points = params.labelLinePoints;
                        //     // Update the end point.
                        //     points[2][0] = isLeft
                        //     ? params.labelRect.x
                        //     : params.labelRect.x + params.labelRect.width;
                        //     return {
                        //         labelLinePoints: points
                        //     };
                        // },
                        data: dataArr
                    }
                ]
            }

            this.chart = echarts.init(this.$refs.chartDom);
            this.chart.setOption(this.option);
            window.addEventListener("resize", () => {
                // 调用 echartsInstance.resize 改变图表的大小
                this.chart.resize();
            });
        },
    },
    created(){
        // this.chart = echarts.init(this.$refs.chartDom);
        // window.addEventListener("resize", () => {
        //     // 调用 echartsInstance.resize 改变图表的大小
        //     this.chart.resize();
        // });

        // setTimeout(() => {
        //     this.init()
        // }, 800);
    }
}
</script>

<style lang="scss" scoped>
#myEcharts {
  width: 100%;
  height: 100%;
}

</style>